import { default as Box } from '@mui/material/Box';
import { BoldLabel, LightGrayLabel } from 'components/labels';
import { getTrans } from 'modules/i18n';
import { ModifiedChangeSetData } from '../types';

export const ChangeSetItem = ({ item }: { item: ModifiedChangeSetData }) => {
  if (!item?.label) return null;
  return (
    <Box sx={{ pb: 2 }}>
      <BoldLabel>{getTrans(item.label) ?? ''}</BoldLabel>
      <LightGrayLabel variant="body2" sx={{ whiteSpace: 'normal' }}>
        {item.value}
      </LightGrayLabel>
    </Box>
  );
};
